import React from "react";
import {
  Card,
  Button,
  Table,
  Space,
  Dropdown,
  Typography,
  Tag,
} from "antd";
import {
  MoreOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

const { Text, Paragraph } = Typography;

const dataSource = [
  {
    key: "1",
    description: "Backup 2025-12-24T06:17:05Z",
    created: "about 4 hours ago",
    size: "2.51 GB",
    status: "Available",
  },
  {
    key: "2",
    description: "Backup 2025-12-23T06:17:07Z",
    created: "1 day ago",
    size: "2.41 GB",
    status: "Available",
  },
  {
    key: "3",
    description: "Backup 2025-12-22T06:17:06Z",
    created: "2 days ago",
    size: "2.37 GB",
    status: "Available",
  },
  {
    key: "4",
    description: "Backup 2025-12-21T06:17:05Z",
    created: "3 days ago",
    size: "2.89 GB",
    status: "Available",
  },
  {
    key: "5",
    description: "Backup 2025-12-20T06:17:06Z",
    created: "4 days ago",
    size: "2.46 GB",
    status: "Available",
  },
  {
    key: "6",
    description: "Backup 2025-12-19T06:17:09Z",
    created: "5 days ago",
    size: "2.46 GB",
    status: "Available",
  },
  {
    key: "7",
    description: "Backup 2025-12-18T06:17:07Z",
    created: "6 days ago",
    size: "2.21 GB",
    status: "Available",
  },
];

const menuItems = [
  { key: "restore", label: "Restore" },
  { key: "download", label: "Download" },
  { key: "delete", label: "Delete", danger: true },
];

const columns = [
  {
    title: "DESCRIPTION",
    dataIndex: "description",
    key: "description",
    render: (text) => <Text strong>{text}</Text>,
  },
  {
    title: "CREATED",
    dataIndex: "created",
    key: "created",
    sorter: true,
  },
  {
    title: "IMAGE SIZE",
    dataIndex: "size",
    key: "size",
  },
  {
    title: "STATUS",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <Tag color="green">{status}</Tag>
    ),
  },
  {
    key: "actions",
    align: "right",
    render: () => (
      <Dropdown
        menu={{ items: menuItems }}
        trigger={["click"]}
      >
        <Button
          type="text"
          icon={<MoreOutlined />}
        />
      </Dropdown>
    ),
  },
];

export default function Backups() {
  return (
    <Space
      direction="vertical"
      size="large"
      style={{ width: "100%" }}
    >
      {/* INFO CARD */}
      <Card>
        <Typography.Title level={4}>
          BACKUPS
        </Typography.Title>

        <Paragraph>
          Backups are automatic copies of your server’s disks.
          For every server there are seven slots for backups.
        </Paragraph>

        <Paragraph>
          If all slots are full and an additional one is created,
          the oldest backup will be deleted.
        </Paragraph>

        <Paragraph>
          We recommend that you power off your server before
          creating a backup to ensure data consistency.
        </Paragraph>

        <Paragraph>
          <ExclamationCircleOutlined /> Enabling backups will
          cost <b>20%</b> of your server plan per month.
        </Paragraph>

        <Space>
          <Button danger type="primary">
            Run Manual Backup
          </Button>
          <Button>
            Disable Backups
          </Button>
        </Space>
      </Card>

      {/* BACKUPS TABLE */}
      <Card>
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
      </Card>
    </Space>
  );
}
